import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

const object = {
  // for Development
  // baseURL: `http://advisoryapp.eastus.cloudapp.azure.com:8080/workflow/`,
  // baseURL: `http://dev.savart.com/workflow/`
  // baseURL: `https://staging.savart.com/workflow/`,
  // baseURL: `http://localhost:8000/workflow/`,
  // baseURL: `http://44.204.134.75/customer/workflow`,
  // for Production
  baseURL: `/workflow/`,
};

const api = axios.create(object);
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers.Authorization = token ? "Bearer " + token : "";
  return config;
});
// api.interceptors.response.use(response => {

//   return response;
// }, error => {

//   let message = (error && error.toJSON().message && error.toJSON().message.indexOf("401") > -1) ? "Session Expired..!" :
//       (error && error.toJSON().message && error.toJSON().message) ? error.toJSON().message : "Bad Gateway..!"
//       toast.error(message)
//   if (message === "Session Expired..!") {
//     toast.dismiss()
//     localStorage.setItem("logOut",true);

//   }
//   return Promise.reject(error);
// })

export default api;
